module.exports = __webpack_public_path__ + "img/1.6a084c18.png";